import { useMutation } from "@tanstack/react-query";
import {
	type DocumentUploadRequestDTO,
	postDocumentV2,
} from "web_myplann/Infrastructure/Api/Api";
import { processResponse } from "web_myplann/Infrastructure/Api/ApiUtils";

export const useDocumentUploadMutation = () => {
	return useMutation({
		mutationFn: processResponse((args: { data: DocumentUploadRequestDTO }) =>
			postDocumentV2(args.data),
		),
	});
};
